<template>
	<div
		data-cart-mini
		:class="$style['cart-mini']"
		@click="$emit('toggle')"
	>
		<div
			:class="$style['cart-mini__container']"
		>
			<FontAwesomeIcon
				:class="$style['cart-mini__container__content__icon']"
				:icon="['fal', 'shopping-cart']"
				size="lg"
			/>
			<div
				:class="$style['cart-mini__products-count']"
			>
				<FontAwesomeIcon
					v-if="loading"
					:class="$style['cart-mini__products-loading']"
					:icon="['far', 'circle-notch']"
				/>
				<span v-else>{{ cart?.quantity }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CartMini',
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		cart: {
			type: [Object, null],
			default: null
		},
		cartProducts: {
			type: [Array, null],
			default: null
		}
	}

}
</script>
<style module lang="scss">
.cart-mini {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin: $gutter * 2;
    cursor: pointer;
    z-index: 1001;
    background-color: getColor(surface-elevated);
    box-shadow: 0 4px 16px getColor(shadow);
    border: 1px solid getColor(border);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

    @include dark-mode-border-fix(border);

    &:hover {
        transform: scale(1.05) translateY(-2px);
        box-shadow: 0 6px 20px getColor(shadow-dark);
        background-color: getColor(hover-overlay);
    }

    &:active {
        transform: scale(0.98);
        box-shadow: 0 2px 8px getColor(shadow);
    }

    @include media-breakpoint-down(sm) {
        width: 50px;
        height: 50px;
        margin: $gutter;
    }

    &--hidden {
        opacity: 0;
        pointer-events: none;
        transform: scale(0.8);
    }

    &__container {
        position: relative;
        margin-left: -3px;
        margin-top: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__container__content__icon {
        font-size: 24px;
        height: 25px;
        width: 25px;
        max-height: 25px;
        max-width: 25px;
        color: getColor(icon);
        transition: color 0.2s ease;

        @include media-breakpoint-down(sm) {
            font-size: 20px;
            height: 20px;
            width: 20px;
        }

        .cart-mini:hover & {
            color: getColor(icon-active);
        }
    }

    &__products-count {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -5px;
        right: -7px;
        background-color: getColor(danger);
        color: getColor(white);
        font-size: 10px;
        line-height: 1;
        font-weight: 700;
        min-width: 15px;
        height: 15px;
        padding: 0 3px;
        border-radius: 100px;
        border: 2px solid getColor(surface-elevated);
        box-shadow: 0 1px 3px getColor(shadow);
        animation: badge-pop 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);

        @include media-breakpoint-down(sm) {
            font-size: 9px;
            min-width: 14px;
            height: 14px;
            top: -3px;
            right: -5px;
        }

        &--empty {
            display: none;
        }

        &--large {
            min-width: 18px;
            height: 18px;
            font-size: 9px;
            padding: 0 4px;
        }
    }

    &__products-loading {
        animation: rotator 1.4s linear infinite;
        color: getColor(primary);
    }

    &--pulsing {
        animation: cart-pulse 2s ease-in-out infinite;
    }
}

@keyframes rotator {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(270deg);
    }
}

@keyframes badge-pop {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes cart-pulse {
    0%, 100% {
        box-shadow: 0 4px 16px getColor(shadow);
    }

    50% {
        box-shadow: 0 4px 16px getColor(primary), 0 0 0 4px getColor(primary-bg-hover);
    }
}

</style>
